import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

const createStoreConnectedAxios = (options: AxiosRequestConfig = {}): AxiosInstance => {
  const axiosInstance = axios.create(options);

  axiosInstance.interceptors.request.use((config) => {
    config.withCredentials = true;
    return config;
  });

  return axiosInstance;
};

export default createStoreConnectedAxios;
